import components from './components'
import mounted from './mounted'
import methods from './methods'
import data from './data'

export default {
  data,
  components,
  mounted,
  methods,
  resourcePath: '/v1/dweller'
}



// WEBPACK FOOTER //
// ./src/app/tenant/dashboard/gadget/resources/index.js